import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const s = r(
  (o, l) => /* @__PURE__ */ e.jsx(
    i,
    {
      ref: l,
      ...o,
      image: (a) => /* @__PURE__ */ e.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 32,
          height: 32,
          fill: "none",
          viewBox: "0 0 32 32",
          ...a,
          children: /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M7.166 8.802C4.87 7.697 4.252 2.327 6.029 2l19.956.016c1.777.327 1.202 5.68-1.093 6.786C23.054 14.766 19.305 17 16.029 17c-3.277 0-7.025-2.234-8.863-8.198m3.39 11.167v-2.705C12.262 18.439 14.152 19 16.029 19c1.855 0 3.724-.549 5.415-1.697v2.666a2 2 0 0 0 1.431 1.917l6.41 1.902a1 1 0 0 1 .715.958V29a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-4.254a1 1 0 0 1 .716-.958l6.408-1.902a2 2 0 0 0 1.432-1.917",
              clipRule: "evenodd"
            }
          )
        }
      )
    }
  )
);
s.displayName = "NeckIcon";
export {
  s as NeckIcon,
  s as default
};
//# sourceMappingURL=index.js.map
